import { create } from 'zustand';
import ServiceTabelas from '@/services/ServiceTabelas';
import { notify } from '@/stores/useToast';

type Tabela = any;

interface State {
  lista: Tabela[];
  carregando: boolean;
  buscar: () => Promise<void>;
}

export const useTabelasStore = create<State>((set) => ({
  lista: [],
  carregando: false,
  async buscar() {
    set({ carregando: true });
    try {
      const { data } = await ServiceTabelas.listar();
      set({ lista: Array.isArray(data) ? data : (data.content ?? data.tables ?? []) });
    } catch {
      notify.error('Erro ao buscar tabelas.');
    } finally {
      set({ carregando: false });
    }
  },
}));
